import { Link } from 'react-router-dom';

const footerLinks = {
  sluzby: {
    title: 'Služby',
    links: [
      { label: 'Weby', href: '#sluzby' },
      { label: 'E-shopy', href: '#sluzby' },
      { label: 'Marketing', href: '#sluzby' },
      { label: 'Sociálne siete', href: '#sluzby' },
      { label: 'Správa systémov', href: '#sluzby' },
    ],
  },
  projekty: {
    title: 'Projekty',
    links: [
      { label: 'Referencie', href: '/referencie' },
      { label: 'Case study - salenbike.sk', href: '/case-study/salenbike' },
      { label: 'Blog', href: '/blog' },
    ],
  },
  firma: {
    title: 'Firma',
    links: [
      { label: 'O Boostio', href: '/o-nas' },
      { label: 'Blog', href: '/blog' },
      { label: 'Kontakt', href: '#kontakt' },
    ],
  },
  pravne: {
    title: 'Právne',
    links: [
      { label: 'Obchodné podmienky', href: '/obchodne-podmienky' },
      { label: 'Ochrana súkromia', href: '/ochrana-sukromia' },
      { label: 'Cookies', href: '/cookies' },
    ],
  },
};

const socialLinks = [
  { icon: 'ri-facebook-fill', label: 'Facebook', href: '#' },
  { icon: 'ri-instagram-line', label: 'Instagram', href: '#' },
  { icon: 'ri-linkedin-fill', label: 'LinkedIn', href: '#' },
  { icon: 'ri-youtube-fill', label: 'YouTube', href: '#' },
];

export default function FooterSection() {
  const scrollTo = (hash: string) => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800/50">
      {/* CTA Banner */}
      <div className="border-b border-zinc-800/50">
        <div className="max-w-7xl mx-auto px-6 py-16 flex flex-col md:flex-row items-center justify-between gap-8">
          <div>
            <p className="text-zinc-500 text-sm uppercase tracking-widest font-semibold mb-2">Pripravení na rast?</p>
            <h3 className="text-white text-3xl md:text-4xl font-black leading-tight">
              Váš web si zaslúži{' '}
              <span className="text-orange-400">lepšie výsledky.</span>
            </h3>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              onClick={() => { const el = document.querySelector('#kontakt'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }}
              className="bg-orange-500 hover:bg-orange-400 text-white font-bold px-7 py-3.5 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center gap-2"
            >
              Získať bezplatnú analýzu
              <i className="ri-arrow-right-line" />
            </button>
            <a
              href="tel:+421905929167"
              className="border border-zinc-700 hover:border-zinc-500 text-white font-semibold px-7 py-3.5 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line" />
              Zavolajte mi
            </a>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-5">
              <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-lg">
                <i className="ri-rocket-2-fill text-white text-sm" />
              </div>
              <span className="text-white font-bold text-xl tracking-tight">
                boost<span className="text-orange-500">io</span>
              </span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed mb-6">
              Digitálny špecialista, ktorý mení kliknutia na zákazníkov. Pracujem s výsledkami, nie so sľubmi.
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-9 h-9 flex items-center justify-center border border-zinc-800 hover:border-orange-500/50 hover:bg-orange-500/10 rounded-lg transition-all duration-200 cursor-pointer text-zinc-400 hover:text-orange-400"
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links columns */}
          {Object.entries(footerLinks).map(([key, section]) => (
            <div key={key}>
              <h4 className="text-white text-sm font-bold mb-5 uppercase tracking-wider">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-zinc-500 hover:text-zinc-300 text-sm transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); scrollTo(link.href); }}
                        className="text-zinc-500 hover:text-zinc-300 text-sm transition-colors duration-200 cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-zinc-800/50">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-zinc-600 text-xs">
            © {new Date().getFullYear()} Kamil Frajtko – Boostio. IČO: 54 125 481 | Neplatca DPH
          </p>
          <div className="flex items-center gap-1 text-zinc-600 text-xs">
            <span>Vyrobené s</span>
            <i className="ri-heart-fill text-orange-500 text-xs" />
            <span>na Slovensku</span>
          </div>
          <div className="flex items-center gap-5">
            <Link to="/ochrana-sukromia" className="text-zinc-600 hover:text-zinc-400 text-xs cursor-pointer">Ochrana súkromia</Link>
            <Link to="/cookies" className="text-zinc-600 hover:text-zinc-400 text-xs cursor-pointer">Cookies</Link>
            <Link to="/obchodne-podmienky" className="text-zinc-600 hover:text-zinc-400 text-xs cursor-pointer">Obchodné podmienky</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
